<template lang="pug">
.btns
  .detail_btn(
    v-for="(program, index) in programList",
    :key="index",
    :class="{ selected: index == selectIndex }",
    @click="changeIndex(index)"
  ) {{ program.name }}
</template>

<script>
export default {
  name: "SelectBtns",
  props: {
    programList: Array,
    selectIndex: Number,
  },
  methods: {
    changeIndex(index) {
      this.$emit("update:selectIndex", index);
    },
  },
};
</script>

<style scoped lang="scss">
@import "@/assets/style/select_btns.scss";
</style>
